import React, { Component, PropTypes } from 'react';
import InputPassword from 'vendor/react-ux-password-field/src';
import { Modal } from 'react-bootstrap';
import { connectReduxForm } from 'redux-form';
import { validateChangePassword } from 'utils/validateNormalize';
import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './spinnerButton.scss';

@connectReduxForm({
  form: 'changePassword',
  fields: ['oldPassword', 'newPassword', 'alert'],
  validate: validateChangePassword
})
export default class ChangePasswordModal extends Component {

  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  handleSubmit (evt) {
    const {
      fields: {
        alert
      },
      handleSubmit
    } = this.props;
    alert.submitError = false;
    handleSubmit(evt);
  }

  render () {
    const {
      showModal,
      closeModal,
      fields: {
        alert,
        oldPassword,
        newPassword
      },
      submitting
    } = this.props;

    return (
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <form onSubmit={::this.handleSubmit}>
          <Modal.Body>
            { alert.error &&
              <div className="form-group">
                <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}>
                </div>
              </div>
            }

            <div className="row form-horizontal">
              <div className="col-sm-10">

                <div
                    className={
                      'form-group ' +
                      (oldPassword.error &&
                       oldPassword.touched ? 'has-error' : '')
                    }>
                  <label
                      htmlFor="txtOldPassword"
                      className="col-sm-4 control-label">
                    Old Password
                  </label>
                  <div className="col-sm-7">
                    <input
                        id="txtOldPassword"
                        type="password"
                        className="form-control"
                        placeholder="thoo!mu3Da"
                        {...oldPassword} />
                    { oldPassword.error && oldPassword.touched &&
                      <div className="text-danger" dangerouslySetInnerHTML={{__html: oldPassword.error}}></div>
                    }
                  </div>
                </div>

                <div
                    className={
                      'form-group ' +
                      (newPassword.error &&
                       newPassword.touched ? 'has-error' : '')
                    }>
                  <label
                      htmlFor="txtNewPassword"
                      className="col-sm-4 control-label">
                    New Password
                  </label>
                  <div className="col-sm-7">
                    <InputPassword
                        id="txtNewPassword"
                        className="form-control"
                        placeholder="thoo!mu3Da"
                        autoComplete="off"
                        minLength={8}
                        toggleMask={false}
                        {...newPassword} />
                    { newPassword.error && newPassword.touched &&
                      <div className="text-danger" dangerouslySetInnerHTML={{__html: newPassword.error}}></div>
                    }
                  </div>
                </div>

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit"
                    className={'btn btn-primary spinnerButton ' +
                               (submitting ? 'disabled' : '')}>
              <div className="buttonContent">
                <div className="buttonText">
                  {submitting ?
                    'Changing' :
                    'Change'
                  }
                </div>
                {submitting &&
                <div className="spinnerWrapper">
                  <Spinner />
                </div>
                }
              </div>
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/changePasswordModal.jsx